import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";

const SwitchConInput = ({ field, onChange }) => {

  const calcolaTotale = (selezionato, quantita, obj) => {
    if (!selezionato || quantita === 0)
      return 0;
    if (obj.quantitaSoglia && obj.prezzoSoglia && quantita < obj.quantitaSoglia) {
      return obj.prezzoSoglia
    } else {
      return quantita * obj.prezzo + (obj.prezzoBase || 0);
    }
    
  }

  return (
    <>
      <div className={`field mb-4  col-12 ${field.hideInput?"": "md:col-6"}  flex-wrap`}>
        <label htmlFor={field.titolo} className="font-medium text-900">
          {field.titolo}
        </label>
        <div className="flex align-items-center flex-wrap">
          <InputSwitch
            inputId={field.titolo}
            checked={field.valore}
            onChange={(e) => {
              onChange({
                ...field,
                valore: e.value,
                totale: calcolaTotale(e.value, field.quantita, field)
              }
              )
            }}
          />
          <br />
          <span className="ml-2">
            {/*{field.descrizione} ({field.prezzo}€{field.descQuantita? `/${field.descQuantita}`: ''}{field.prezzoBase? (' + '+field.prezzoBase + '€'): '' })*/}
            {field.descrizione}
          </span>
        </div>
      </div>
      {/*** input***/}
      {field.valore && !field.hideInput && 
        <div className="field mb-4 col-12 md:col-6 flex flex-column">
          <label
            htmlFor="quantitaID"
            className="font-medium text-900"
          >
           {field.descrizioneQuantita}
          </label>
          <InputNumber
            id="quantitaID"
            prefix={field.descQuantita + " "}
            placeholder={field.descrizioneQuantita}
            value={field.quantita}
            onChange={(e) =>
              onChange({
                ...field,
                quantita: e.value,
                totale: calcolaTotale(field.valore, e.value, field)
              })
            }
            min="0"
            maxFractionDigits={2}
            locale="it-IT"
            className="w-full md:w-14rem"
          />
        </div>
      }
    </>
  );
};

export default SwitchConInput;
